import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "galerie",
  "use": "galerie-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"galerie\"><path d=\"M1 13a1 1 0 011 1v14h14a1 1 0 010 2H1a1 1 0 01-1-1V14a1 1 0 011-1zm30-9a2 2 0 012 2v17a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h24zm-17.683 8.803L8 18.12V22h22v-4.563l-2.659-2.658-5.488 5.488-.591.653-7.945-8.117zM30 7H8v6.878l5.328-5.328 2.122 2.122 5.868 5.888 6.01-6.01.683.683.014-.013L30 13.195V7z\" fill=\"#E30000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol